/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  PutApiV1BannerId202,
  PutApiV1BannerId400,
  PutApiV1BannerId401,
  PutApiV1BannerId404,
  PutApiV1BannerId500,
  PutApiV1BannerIdMutationRequest,
  PutApiV1BannerIdMutationResponse,
  PutApiV1BannerIdPathParams,
} from "../../types/bannerRegistroController/PutApiV1BannerId.ts";
import { bannerViewModelSchema } from "../bannerViewModelSchema.ts";
import { eBannerPositionSchema } from "../eBannerPositionSchema.ts";
import { eBannerPrioritySchema } from "../eBannerPrioritySchema.ts";

export const putApiV1BannerIdPathParamsSchema = z.object({
  id: z.coerce.number().int(),
}) as unknown as ToZod<PutApiV1BannerIdPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const putApiV1BannerId202Schema = z.lazy(
  () => bannerViewModelSchema,
) as unknown as ToZod<PutApiV1BannerId202>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const putApiV1BannerId400Schema =
  z.any() as unknown as ToZod<PutApiV1BannerId400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const putApiV1BannerId401Schema =
  z.any() as unknown as ToZod<PutApiV1BannerId401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const putApiV1BannerId404Schema =
  z.any() as unknown as ToZod<PutApiV1BannerId404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const putApiV1BannerId500Schema =
  z.any() as unknown as ToZod<PutApiV1BannerId500>;

export const putApiV1BannerIdMutationRequestSchema = z.object({
  CompanyId: z.optional(z.number().int()),
  Title: z.optional(z.string()),
  ShowTitle: z.optional(z.boolean()),
  StartDate: z.optional(z.string().datetime()),
  EndDate: z.optional(z.string().datetime()),
  Position: z.optional(
    z
      .lazy(() => eBannerPositionSchema)
      .describe("1 = Top | 2 = MiddleStart | 3 = MiddleEnd | 4 = Bottom | "),
  ),
  Duration: z.optional(z.number().int()),
  Priority: z.optional(
    z
      .lazy(() => eBannerPrioritySchema)
      .describe(
        "1 = VeryLow | 2 = Low | 3 = Medium | 4 = High | 5 = VeryHigh | ",
      ),
  ),
  Url: z.optional(z.string()),
  General: z.optional(z.boolean()),
  IsMonograph: z.optional(z.boolean()),
  IsMonitor: z.optional(z.boolean()),
  AllowedEnrollmentStatus: z.optional(z.string()),
  Active: z.optional(z.boolean()),
  Image: z.optional(z.instanceof(File)),
  Video: z.optional(z.instanceof(File)),
  ImageMobile: z.optional(z.instanceof(File)),
  VideoMobile: z.optional(z.instanceof(File)),
  ClassStudentIds: z.optional(z.array(z.number().int())),
}) as unknown as ToZod<PutApiV1BannerIdMutationRequest>;

export const putApiV1BannerIdMutationResponseSchema = z.lazy(
  () => putApiV1BannerId202Schema,
) as unknown as ToZod<PutApiV1BannerIdMutationResponse>;
